import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe, login as apiLogin, logoutSession } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    // Server is source of truth: accepts session_token cookie (Google) or JWT Bearer (email/password)
    getMe()
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem('auth_token');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await apiLogin(email, password);
    const { token, user: userData } = res.data;
    localStorage.setItem('auth_token', token);
    setUser(userData);
    return userData;
  };

  // Called by AuthCallback after a successful Google session exchange
  const completeOAuth = (userData) => {
    localStorage.removeItem('auth_token'); // session is cookie-based now
    setUser(userData);
  };

  const logout = () => {
    logoutSession().catch(() => {});
    localStorage.removeItem('auth_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, completeOAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
